
import { defineComponent } from 'vue';
import { NIcon, NButton } from '@/uikit';

export default defineComponent({
  name: 'LoginWaitFaceAuth',
  components: { NIcon }
});
